"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@material-ui/core/styles");
const styles = (theme) => (0, styles_1.createStyles)({
    topLeft: {
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderStyle: 'solid',
        borderRightColor: 'transparent !important',
        borderBottomColor: 'transparent !important',
        borderLeftColor: 'transparent !important',
        filter: 'drop-shadow(1px 1px 1px rgba(0,0,0,.5))'
    },
    topLeftNoShadow: {
        borderBottomWidth: 0,
        borderLeftWidth: 0,
        borderStyle: 'solid',
        borderRightColor: 'transparent !important',
        borderBottomColor: 'transparent !important',
        borderLeftColor: 'transparent !important'
    },
    topRight: {
        borderTopWidth: 0,
        borderLeftWidth: 0,
        borderStyle: 'solid',
        borderTopColor: 'transparent !important',
        borderBottomColor: 'transparent !important',
        borderLeftColor: 'transparent !important'
    },
    downLeft: {
        borderRightWidth: 0,
        borderBottomWidth: 0,
        borderStyle: 'solid',
        borderTopColor: 'transparent !important',
        borderRightColor: 'transparent !important',
        borderBottomColor: 'transparent !important'
    },
    downRight: {
        borderTopWidth: 0,
        borderRightWidth: 0,
        borderStyle: 'solid',
        borderTopColor: 'transparent !important',
        borderRightColor: 'transparent !important',
        borderLeftColor: 'transparent !important'
    },
    container: {
        position: 'absolute',
        zIndex: 1
    },
    iconLeft: {
        position: 'absolute',
        bottom: theme.spacing(),
        left: theme.spacing()
    },
    iconRight: {
        position: 'absolute',
        bottom: theme.spacing(),
        left: theme.spacing(3)
    },
    textView: {
        position: 'absolute',
        top: theme.spacing() + 4,
        left: theme.spacing() + 4
    },
    iconView: {
        position: 'absolute',
        top: theme.spacing(),
        left: theme.spacing()
    },
    imageView: {
        position: 'absolute',
        top: theme.spacing() - 6,
        left: theme.spacing() - 6
    }
});
exports.default = styles;
//# sourceMappingURL=TriangleStyle.js.map